export class GetOperationsParams {
  after: number
  limit: number

  constructor({ after, limit }: { after: number, limit: number }) {
    this.after = after
    this.limit = limit
  }
}
